module.exports = __webpack_public_path__ + "static/media/c1_5.354dfcb6.png";